import {
  Dialog as MaterialDialog,
  IconButton,
  Tooltip,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InfoIcon from "@mui/icons-material/Info";
import React, { useState } from "react";
import styles from "./styles";
import Grid2 from "@mui/material/Unstable_Grid2";

interface Props {
  image?: ImageBitmap | any;
}

const Dialog: React.FC<Props> = ({ image }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box className={"containerDialog"} sx={styles}>
      <IconButton color="inherit" onClick={handleOpen} className={"iconButton"}>
        <Tooltip title="Où trouver cette info ?">
          <InfoIcon />
        </Tooltip>
      </IconButton>
      <MaterialDialog
        onClose={handleClose}
        aria-labelledby="simple-dialog-title"
        open={open}
      >
        <Grid2 container justifyContent="flex-end">
          <IconButton
            aria-label="close"
            className={"closeButton"}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        </Grid2>
        {image && <img src={image} alt="" />}
      </MaterialDialog>
    </Box>
  );
};

export default Dialog;
